import { render, staticRenderFns } from "./wechat_qrcode.vue?vue&type=template&id=40b6a8ee&scoped=true"
import script from "./wechat_qrcode.vue?vue&type=script&lang=js"
export * from "./wechat_qrcode.vue?vue&type=script&lang=js"
import style0 from "./wechat_qrcode.vue?vue&type=style&index=0&id=40b6a8ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6a8ee",
  null
  
)

export default component.exports